import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSend, FiMessageCircle, FiFileText, FiCheckCircle, FiClock } = FiIcons;

const RenewalPipeline = ({ items }) => {
  const stages = [
    { label: 'Notice Sent', icon: FiSend, color: 'text-blue-500', bg: 'bg-blue-50' },
    { label: 'In Negotiation', icon: FiMessageCircle, color: 'text-amber-500', bg: 'bg-amber-50' },
    { label: 'Drafting', icon: FiFileText, color: 'text-purple-500', bg: 'bg-purple-50' },
    { label: 'Renewed', icon: FiCheckCircle, color: 'text-green-500', bg: 'bg-green-50' }
  ];

  const getStageItems = (stageLabel) => {
    return items.filter(item => {
      if (stageLabel === 'Notice Sent') return item.riskScore < 100 && item.riskScore > 60;
      if (stageLabel === 'Renewed') return item.daysLeft > 120; // Simulated
      return false;
    });
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {stages.map((stage, idx) => {
        const stageItems = getStageItems(stage.label);
        return (
          <div key={idx} className="bg-gray-50/50 rounded-3xl p-4 border border-gray-100 flex flex-col min-h-[150px]">
            <div className="flex items-center gap-2 mb-4">
              <div className={`p-1.5 rounded-lg ${stage.bg} ${stage.color}`}>
                <SafeIcon icon={stage.icon} size={14} />
              </div>
              <h4 className="text-[10px] font-black text-gray-600 uppercase tracking-widest">{stage.label}</h4>
              <span className="ml-auto text-[10px] font-black text-gray-400 bg-white px-2 py-0.5 rounded-full border border-gray-100">
                {stageItems.length}
              </span>
            </div>
            
            <div className="space-y-2 flex-1">
              {stageItems.map(item => (
                <div key={item.id} className="bg-white p-3 rounded-xl border border-gray-100 shadow-sm text-[10px] font-bold text-gray-700">
                  {item.name}
                  <div className="flex items-center gap-1 mt-1 text-[8px] text-gray-400 uppercase">
                    <SafeIcon icon={FiClock} size={8} /> {item.daysLeft}d left
                  </div>
                </div>
              ))}
              {stageItems.length === 0 && (
                <div className="flex-1 flex items-center justify-center border border-dashed border-gray-200 rounded-2xl">
                  <span className="text-[10px] font-black text-gray-300 uppercase">Empty</span>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RenewalPipeline;